export interface Faq {
  id: string;
  category: string;
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    id: 'faq-what',
    category: '网站说明',
    question: '西瓜黑料是一个什么样的网站？',
    answer:
      '西瓜黑料是一个以时间线方式梳理网络热点的吃瓜资讯站。我们不满足于零散爆料，而是把每一段瓜的起因、经过、后续、反转与结局按时间顺序排成一条完整的线，让你像追连续剧一样看懂前因后果。',
  },
  {
    id: 'faq-timeline',
    category: '网站说明',
    question: '时间线是怎么整理的？',
    answer:
      '每次有新进展，我们会在对应事件下新增一个时间线节点，并标注类型：起始、后续、反转或结局。节点会按日期先后排列，事件顶部显示当前进度百分比，方便你判断这出戏演到哪一幕了。',
  },
  {
    id: 'faq-diff',
    category: '使用指南',
    question: '「后续瓜」「反转」和「续集」有什么区别？',
    answer:
      '后续瓜指事件新的进展，通常沿着同一逻辑继续发展；反转指出现与先前说法相反的新信息，会改变原有的判断；续集则指事件告一段落后又因新原因重新被提起。三者会同时出现在一条时间线中，用不同标记区分。',
  },
  {
    id: 'faq-ending',
    category: '内容与更新',
    question: '已经标注结局的事件，还会再更新吗？',
    answer:
      '会。标注为结局只代表当前阶段有了结果，并不排除后续出现新的续集。一旦有值得收录的新进展，我们会重新开启时间线并更新状态，页面顶部的进度也会随之调整。',
  },
  {
    id: 'faq-source',
    category: '内容与更新',
    question: '站内的内容来源是哪里？',
    answer:
      '站内内容由编辑团队根据公开可查的信息整理与梳理，重点在于把分散的信息按时间线串起来。人物与事件均经过创作化处理与匿名化表达，主要用于呈现信息结构，不构成对任何真实个人或机构的评价。',
  },
  {
    id: 'faq-sort',
    category: '使用指南',
    question: '瓜田总览页可以怎么筛选？',
    answer:
      '在瓜田总览页，你可以按娱乐圈瓜、网红翻车、商业互撕、科技圈瓜、综艺影视五个分类切换，也可以直接输入关键词搜索，还能在「按热度」与「按最新」之间排序，快速定位你关心的那条线。',
  },
  {
    id: 'faq-subscribe',
    category: '使用指南',
    question: '怎样第一时间收到新进展？',
    answer:
      '页面底部提供订阅入口，填写邮箱即可加入瓜讯订阅清单。当有重大反转或结局更新时，我们会通过邮件提醒你，免得你错过关键一幕。',
  },
  {
    id: 'faq-submit',
    category: '内容与更新',
    question: '可以投稿线索吗？',
    answer:
      '欢迎。你可以通过站点底部的联系方式与我们取得联系，附上可公开核实的时间与信息来源。编辑团队会先做核对，再决定是否整理成时间线发布。',
  },
];